import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";

import PageNotFound from './views/errors/Error404.vue';

import Home from "./views/investments/Home.vue";
import Municipalities from "./views/investments/Municipalities.vue";
import Governances from "./views/investments/Governances.vue";
import MunicipalitiesNational from "./views/investments/MunicipalitiesNational.vue";


import Region from "./views/investments/Region.vue";
import RegionSingle from "./views/investments/RegionSingle.vue";
import MunicipalitiesList from "./views/investments/MunicipalitiesList.vue";


Vue.use(Router);

//export default new Router({
const router = new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [

    /** CUSTOM ROUTES */

    { // wildcard
      path: '*',
      redirect: {
        name: 'error404',
      }
    }, 
    { // Page Error
      path: "/404",
      name: 'error404',
      components: {
        header: AppHeader,
        default: PageNotFound,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Página no encontrada' }
    },
    { // Home Index
      path: "/", 
      name: "investment.home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Inicio | Ranking en Igualdad y Equidad de Género' }
    },
    { //List of all Municipalities By Year and City
      path: "/inversiones/:year/t/municipios/:city/:name",
      name: "investment.municipalities",
      components: {
        header: AppHeader,
        default: Municipalities,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Municipios | Ranking en Igualdad y Equidad de Género' }
    },
    { //List of Governance By Year and City
      path: "/inversiones/:year/t/gobernaciones/:city/:name",
      name: "investment.governances",
      components: {
        header: AppHeader,
        default: Governances,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Gobernaciones | Ranking en Igualdad y Equidad de Género' }
    },
    { //List Municipalities of Bolivia By Year and City
      path: "/inversiones/:year/t/municipios/:city/bolivia/nacional",
      name: "investment.municipalities.national",
      components: {
        header: AppHeader,
        default: MunicipalitiesNational,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Bolivia Municipios | Ranking en Igualdad y Equidad de Género' }
    },
    { //Single municipality
      path: "/inversiones/:year/t/:type/region/:code/:name",
      name: "investment.region.single",
      components: {
        header: AppHeader,
        default: RegionSingle,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Municipio | Ranking en Igualdad y Equidad de Género' }
    },
    { // List Table of Municipalities by City
      path: "/inversiones/:year/municipios/:city/listado",
      name: "investment.municipalities.list",
      components: {
        header: AppHeader,
        default: MunicipalitiesList,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Listado por región | Ranking en Igualdad y Equidad de Género' }
    },



    {
      path: "/inversiones/:gestion/region/:code",
      name: "investment.region",
      components: {
        header: AppHeader,
        default: Region,
        footer: AppFooter
      },
      meta: { Auth: false, title: 'Detalle de un Municipio | Ranking en Igualdad y Equidad de Género' }
    },
    
    
    

    /** ROUTES */
    {
      path: "/home", /* / */
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/profile",
      name: "profile",
      components: {
        header: AppHeader,
        default: Profile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
}) ;

export default router;